<template>
    <div>
        <div v-for="availabilityOffer in availabilityOffers" :key="availabilityOffer.id" :class="classList">
            <div :class="daysClassList(availabilityOffer)" @click="allowSelection ? null : openAvailability(availabilityOffer)">
                <div v-for="(day, index) in getDays(availabilityOffer)" :key="index" class="offer-availability__day">
                    <p v-if="index === 0" class="offer-availability__days--header">
                        <span class="offer-availability__days--header--text">
                            {{ availabilityOffer?.availability.titleTextContent.originalText }}
                        </span>
                        <common-button
                            v-if="availabilityOffer.showAddButton"
                            type="secondary"
                            :isProcessing="isLoading"
                            :label="$t('common.microcopy.add')"
                            @click="toggleAvailability(availabilityOffer)"
                        ></common-button>
                    </p>
                    <div>
                        <common-icon class="offer-availability__icon" name="calendar" size="huge"></common-icon>
                        <span class="offer-availability__day--name">{{ day.name }}</span>
                    </div>
                    <div class="offer-availability__time-slots">
                        <common-icon class="offer-availability__icon" name="clock" size="huge"></common-icon>
                        <span v-for="(timeSlot, timeIndex) in day.values" :key="timeIndex" class="offer-availability__time">
                            {{ timeSlot.from }} {{ $t('common.microcopy.to') }} {{ timeSlot.to }}
                            {{ checkIfNeedPipe(timeIndex, day) }}
                            &nbsp;
                        </span>
                    </div>
                </div>
            </div>
            <div v-if="!allowSelection" class="offer-availability__moderator">
                <span v-if="isUserPerformerOrModerator(availabilityOffer)" class="offer-availability__moderator--icons">
                    <common-icon
                        v-if="!allowSelection"
                        class="offer-availability__moderator--icons-edit"
                        name="reservation"
                        size="huge"
                        @click="openAvailability(availabilityOffer)"
                    ></common-icon>
                    <common-icon
                        class="offer-availability__moderator--icons-delete"
                        name="trash"
                        size="huge"
                        @click="openRemoveAvailabilityModal(availabilityOffer)"
                    ></common-icon>
                </span>
                <common-user-avatar :user="getPerformerUser(availabilityOffer)" size="medium"></common-user-avatar>
                <div class="offer-availability__moderator--name">{{ getPerformerUserName(availabilityOffer) }}</div>
                <common-content-spacer height="small">
                    <common-buttons v-if="isUserPerformerOrModerator(availabilityOffer)" align="right">
                        <common-button
                            :label="$t('pages.company.my_company.buttons.add_inactivity')"
                            type="primary"
                            :isSubmittable="false"
                            size="tiny-micro"
                            @click="openInactivityModal(availabilityOffer)"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </div>
            <div v-if="allowSelection && availabilityOffer.linkedOffers.length" class="offer-availability__linked--offers">
                <common-badges-link-list :listElements="availabilityOffer.linkedOffers"></common-badges-link-list>
            </div>
        </div>
        <common-yes-no-modal
            v-if="isYesNoModalOpen"
            :showWarningIcon="true"
            height="tiny"
            :headingText="headingYesNoModal"
            :noButtonText="$t('common.microcopy.close')"
            :yesButtonText="yesTextYesNoModal"
            @close="closeYesNoModal"
            @continue="continueYesNoModal"
        ></common-yes-no-modal>
        <add-inactivity-modal
            v-if="isAddInactivityModalOpen"
            @close="closeInactivityModal()"
            @out-if-avilability="outOfAvilabilityEvent($event)"
        ></add-inactivity-modal>
        <out-of-availability-modal
            v-if="isOutOfAvailabilityModalOpen"
            :offers="offersOutOfAvailability"
            @close="closeOutOfAvailabilityModal"
            @accepted="isRemoveAvailabilityInProcess ? submitRemoveAvailabilityFormData() : submitInactivityFormData()"
        ></out-of-availability-modal>
    </div>
</template>

<script>
    import DaysEnum from 'enums/days.enum'
    import availabilityTransformer from 'transformers/availabilityTransformer'
    import UsersAPI from 'api/UsersAPI'
    import CompanyAPI from 'api/CompanyAPI'
    import AvailabilityUserRoleEnum from 'enums/availability_user_role.enum'
    const isEqual = require('lodash.isequal')
    import AddInactivityModal from 'components/modals/company/AddInactivityModal'
    import OfferAPI from 'api/OfferAPI'
    import OutOfAvailabilityModal from 'components/modals/availability/OutOfAvailabilityModal'
    import AvailabilityAPI from 'api/AvailabilityAPI'
    import dayjs from 'dayjs'
    import Store from '~/store'

    export default {
        components: {
            AddInactivityModal,
            OutOfAvailabilityModal,
        },
        props: {
            availabilityOffers: { type: Object, required: true },
            allowSelection: { type: Boolean, defaul: false },
            isOfferForComapny: { type: Boolean, defaul: false },
            companyId: { type: Number, default: null },
            timeZone: { type: String, required: true },
        },

        data() {
            return {
                user: this.$auth.getUser(),
                offerList: [],
                isLoading: false,
                isYesNoModalOpen: false,
                isRemoveAvailabilityInProcess: false,
                availabilityOfferId: null,
                availabilityId: null,
                isAddInactivityModalOpen: false,
                isOutOfAvailabilityModalOpen: false,
                offersOutOfAvailability: [],
                event: [],
            }
        },

        computed: {
            dayNames() {
                return Object.values(DaysEnum[this.$i18n.locale])
            },

            classList() {
                return {
                    'offer-availability': true,
                    'offer-availability__selection': this.allowSelection,
                }
            },

            headingYesNoModal() {
                return this.isRemoveAvailabilityInProcess
                    ? this.$t('pages.offer.configure_offer.remove_availability')
                    : this.$t('pages.offer.configure_offer.add_availability_to_offer')
            },

            yesTextYesNoModal() {
                return this.isRemoveAvailabilityInProcess ? this.$t('common.microcopy.delete') : this.$t('common.microcopy.add')
            },
        },

        methods: {
            getDays(availabilityOffer) {
                const timeline = availabilityTransformer.timelineMinutesUTCToTimeLocal(
                    availabilityOffer.availability.timeline,
                    dayjs().tz(this.timeZone).format('YYYY-MM-DD'),
                    this.timeZone,
                )
                return this.dayNames
                    .filter((dayName) => timeline[dayName.value].length)
                    .map((dayName) => ({
                        name: dayName.name.slice(0, 3),
                        values: timeline[dayName.value],
                    }))
                    .reduce((acc, val) => {
                        const existing = acc.find((el) => isEqual(el.values, val.values))
                        if (existing) {
                            existing.name = `${existing.name}, ${val.name}`
                        } else {
                            acc.push(val)
                        }
                        return acc
                    }, [])
            },

            isUserPerformerOrModerator(availability) {
                return availability.availability.availabilityUsers.map((au) => au.user.id).includes(this.$auth.getUser().id)
            },

            getPerformerUser(availability) {
                return availability.availability?.availabilityUsers?.find(
                    (us) => us.function === AvailabilityUserRoleEnum.PERFORMER,
                ).user
            },

            getPerformerUserName(availability) {
                const user = availability.availability?.availabilityUsers?.find(
                    (us) => us.function === AvailabilityUserRoleEnum.PERFORMER,
                )
                return `${user?.user?.firstName ?? ''} ${user?.user?.lastName ?? ''}`
            },

            openAvailability(availabilityOffer) {
                if (this.isUserPerformerOrModerator(availabilityOffer)) {
                    this.emitEvent({ name: 'availability-clicked', payload: availabilityOffer })
                }
            },

            toggleAvailability(availabilityOffer) {
                this.availabilityOfferId = availabilityOffer.id
                this.isYesNoModalOpen = true
            },

            reuseAvailabilityCompany() {
                this.isLoading = true
                const request = {
                    offerId: Number(this.$route.params.id),
                    availabilityId: this.availabilityOfferId,
                    companyId: this.companyId,
                }
                CompanyAPI.reuseAvailability(request).then(() => {
                    this.isLoading = false
                    this.isYesNoModalOpen = false
                    this.emitEvent({ name: 'availability-added' })
                })
            },
            continueYesNoModal() {
                return this.isRemoveAvailabilityInProcess ? this.outOfAvilabilityEvent() : this.reuseAvailability()
            },
            reuseAvailabilityUser() {
                this.isLoading = true
                const request = {
                    offerId: Number(this.$route.params.id),
                    availabilityId: this.availabilityOfferId,
                }
                UsersAPI.reuseAvailability(request).then(() => {
                    this.isLoading = false
                    this.$toast.success(this.$t('common.microcopy.success'))
                    this.isYesNoModalOpen = false
                    this.emitEvent({ name: 'availability-added' })
                })
            },

            reuseAvailability() {
                this.isOfferForComapny ? this.reuseAvailabilityCompany() : this.reuseAvailabilityUser()
            },
            openRemoveAvailabilityModal(availabilityOffer) {
                this.availabilityId = availabilityOffer.availability.id
                this.isRemoveAvailabilityInProcess = true
                this.isYesNoModalOpen = true
            },
            closeYesNoModal() {
                this.isRemoveAvailabilityInProcess = false
                this.isYesNoModalOpen = false
            },
            openInactivityModal(availabilityOffer) {
                this.availabilityId = availabilityOffer.availability.id
                this.isAddInactivityModalOpen = true
            },
            closeInactivityModal() {
                this.isAddInactivityModalOpen = false
            },
            showOutOfAvailabilityModal() {
                this.isOutOfAvailabilityModalOpen = true
            },

            closeOutOfAvailabilityModal() {
                this.closeYesNoModal()
                this.isOutOfAvailabilityModalOpen = false
            },
            outOfAvilabilityEvent(event) {
                Store.dispatch('configuration/setIsLoading', true)

                this.event = event
                let offerId = null
                if ((this.event && this.event.allAvailabilityIds) || this.isRemoveAvailabilityInProcess) {
                    offerId = Number(this.$route.params.id)
                }
                OfferAPI.getAffectedAvailabilityEvents({
                    availabilityIds: [this.availabilityId],
                    dateFrom: this.event?.dateFrom ? this.event.dateFrom : null,
                    dateTo: this.event?.dateTo ? this.event.dateTo : null,
                    offerId: offerId,
                }).then((res) => {
                    if (!res.outOfTimeOffers.length) {
                        this.isRemoveAvailabilityInProcess
                            ? this.submitRemoveAvailabilityFormData()
                            : this.submitInactivityFormData()
                    } else {
                        this.offersOutOfAvailability = res.outOfTimeOffers
                        this.showOutOfAvailabilityModal()
                    }
                    Store.dispatch('configuration/setIsLoading', false)
                })
            },
            submitInactivityFormData() {
                AvailabilityAPI.setupInactivity({
                    availabilityIds: [this.availabilityId],
                    dateFrom: this.event.dateFrom,
                    dateTo: this.event.dateTo,
                    offerId: !this.event.allAvailabilityIds ? Number(this.$route.params.id) : null,
                })
                    .then(() => {
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.closeInactivityModal()
                        this.closeOutOfAvailabilityModal()
                        this.$auth.reloadUser()
                    })
                    .catch(() => {})
            },
            submitRemoveAvailabilityFormData() {
                AvailabilityAPI.removeAvailability({
                    availabilityId: Number(this.availabilityId),
                    offerId: Number(this.$route.params.id),
                })
                    .then(() => {
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.emitEvent({ name: 'availability-removed' })
                        this.closeYesNoModal()
                        this.closeOutOfAvailabilityModal()
                        this.$auth.reloadUser()
                    })
                    .catch(() => {})
            },
            checkIfNeedPipe(timeIndex, day) {
                return timeIndex < day.values.length - 1 ? '|' : ''
            },

            daysClassList(availabilityOffer) {
                return {
                    'offer-availability__days': true,
                    'offer-availability__days--click': this.isUserPerformerOrModerator(availabilityOffer),
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/availability/_offer-availability.scss';
</style>
